import SectionHeading from "@/components/SectionHeading";
import AdvisorQuiz from "@/components/AdvisorQuiz";
import { Reveal } from "@/components/Reveal";

export default function AdvisorSection() {
  return (
    <section id="danisman" data-testid="advisor-section" className="obsidian py-24 sm:py-32">
      <div className="container-x grid items-start gap-12 lg:grid-cols-[0.9fr_1.1fr]">
        <Reveal>
          <SectionHeading
            number="03"
            overline="Etkileşimli Danışman"
            title="Aracım için hangi koruma uygun?"
            subtitle="Birkaç soruyla aracınıza en uygun koruma planını ve değer koruma skorunuzu öğrenin. Tamamen ücretsiz, saniyeler içinde."
          />
          <ul className="mt-10 space-y-5">
            {[
              "Aracınıza özel, satış odaklı değil ihtiyaç odaklı öneri",
              "Seramik mi PPF mi sorusuna net cevap",
              "Sonucu tek tıkla WhatsApp'tan paylaşma",
            ].map((t) => (
              <li key={t} className="flex items-start gap-4 text-neutral-300">
                <span className="mt-1.5 h-2 w-2 shrink-0 rotate-45 bg-gold" />
                {t}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.1}>
          <AdvisorQuiz />
        </Reveal>
      </div>
    </section>
  );
}
